"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var MemberCredits_1 = require("../model/MemberCredits");

var MemberCreditsConverter_1 = require("./MemberCreditsConverter");
/**
 * Default implementation of MemberCreditsConverter.
 *
 * @author Radek Beran
 */


var MemberCreditsConverterImpl =
/*#__PURE__*/
function (_MemberCreditsConvert) {
  _inherits(MemberCreditsConverterImpl, _MemberCreditsConvert);

  function MemberCreditsConverterImpl() {
    _classCallCheck(this, MemberCreditsConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(MemberCreditsConverterImpl).apply(this, arguments));
  }

  _createClass(MemberCreditsConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new MemberCredits_1.MemberCredits(MemberCredits_1.MemberCredits.schema.enabled.valueOfField(source), MemberCredits_1.MemberCredits.schema.amountForPurchase.valueOfField(source), !utils_1.Utils.isValueMissing(source.healthyAmountForPurchase) ? MemberCredits_1.MemberCredits.schema.healthyAmountForPurchase.valueOfField(source) : null, MemberCredits_1.MemberCredits.schema.purchaseQuantity.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        enabled: source.enabled,
        amountForPurchase: source.amountForPurchase,
        healthyAmountForPurchase: source.healthyAmountForPurchase,
        purchaseQuantity: source.purchaseQuantity
      });
      return result;
    }
  }]);

  return MemberCreditsConverterImpl;
}(MemberCreditsConverter_1.MemberCreditsConverter);

exports.MemberCreditsConverterImpl = MemberCreditsConverterImpl;